import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import EdiWebTabs from "./EdiWebTabs";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import SalesOrderOptionsButton, { OptionsTabType } from "../common/SalesOrderOptionsButton";
import PrintReportMenu from "../common/PrintReportMenu";
const EdiWebSearchResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "02C4EBBE-A107-4361-A37A-D9BDDB3695DA";
    const [currentLayout, setCurrentLayout]= useState("Default");
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const childRef = useRef();
    const [selectedRecord, setSelectedRecord] = useState(null);

    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
          }
          setSelectedCustomerId(selectedRowData?.rCustomer ?? null);
          setSelectedRowId(selectedRowData?.rowid ?? null);
        setSelectedRecord(selectedRowData);
    };
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="recordNumber" caption='Record#' ></Column>
                <Column dataField="customer" caption='Customer' ></Column>
                <Column dataField="customerName" caption='Name' ></Column>
                <Column dataField="address1" caption='Address- 1'></Column>
                <Column dataField="address2" caption='Address- 2'></Column>
                <Column dataField="city" caption='City'></Column>
                <Column dataField="zip" caption='Zip'></Column>
                <Column dataField="state" caption='State'></Column>
                <Column dataField="consignee" caption='Consignee'></Column>
                <Column dataField="consigneeName" caption='Consignee Name'></Column>
                <Column dataField="consigneeAddress1" caption='Consignee Address- 1'></Column>
                <Column dataField="consigneeAddress2" caption='Consignee Address- 2'></Column>
                <Column dataField="consigneeCity" caption='Consignee City'></Column>
                <Column dataField="consigneeZip" caption='Consignee Zip'></Column>
                <Column dataField="consigneeState" caption='Consignee State'></Column>
                <Column dataField="transactiontype" caption='Type' ></Column>
                <Column dataField="transactionnumber" caption='Transaction.#' ></Column>
                <Column dataField="transactiondate" dataType="date" format="MM/dd/yyyy" caption='Order Date' ></Column>
                <Column dataField="shippingdate" dataType="date" format="MM/dd/yyyy" caption='Ship Date' ></Column>
                <Column dataField="stage" caption='Stage' ></Column>
                <Column dataField="status" caption='Status' ></Column>
                <Column dataField="transactionduedate" dataType="date" format="MM/dd/yyyy" caption='Transaction Due Date'></Column>
                <Column dataField="purchaseordernumber" caption='PO.#'></Column>
                <Column dataField="pricelevel" caption='Pricelevel'></Column>
                <Column dataField="discounttype" caption='Discount type'></Column>
                <Column dataField="discountpercent" caption='Discount Percent'></Column>
                <Column dataField="userdefinedcode1" visible={false} caption="Code1_OMHeader"></Column>
                <Column dataField="userdefinedcode2" visible={false} caption="Code2_OMHeader"></Column>
                <Column dataField="userdefinedcode3" visible={false} caption="Code3_OMHeader"></Column>
                <Column dataField="userdefinedcode4" visible={false} caption="Code4_OMHeader"></Column>
                <Column dataField="userdefinedcode5" visible={false} caption="Code5_OMHeader"></Column>
                <Column dataField="userdefinedcode6" visible={false} caption="Code6_OMHeader"></Column>
                <Column dataField="userdefinedcode7" visible={false} caption="Code7_OMHeader"></Column>
                <Column dataField="userdefinedcode8" visible={false} caption="Code8_OMHeader"></Column>
                <Column dataField="userdefinedcode9" visible={false} caption="Code9_OMHeader"></Column>
                <Column dataField="userdefinedcode10" visible={false} caption="Code10_OMHeader"></Column>
                <Column dataField="userdefinedreference1" visible={false} caption="Reference1_OMHeader"></Column>
                <Column dataField="userdefinedreference2" visible={false} caption="Reference2_OMHeader"></Column>
                <Column dataField="userdefinedreference3" visible={false} caption="Reference3_OMHeader"></Column>
                <Column dataField="userdefinedreference4" visible={false} caption="Reference4_OMHeader"></Column>
                <Column dataField="userdefinedreference5" visible={false} caption="Reference5_OMHeader"></Column>
                <Column dataField="userdefinedreference6" visible={false} caption="Reference6_OMHeader"></Column>
                <Column dataField="userdefinedreference7" visible={false} caption="Reference7_OMHeader"></Column>
                <Column dataField="userdefinedreference8" visible={false} caption="Reference8_OMHeader"></Column>
                <Column dataField="userdefinedreference9" visible={false} caption="Reference9_OMHeader"></Column>
                <Column dataField="userdefinedreference10" visible={false} caption="Reference10_OMHeader"></Column>
                <Column dataField="userdefineddate1" visible={false} caption="Date1_OMHeader"></Column>
                <Column dataField="userdefineddate2" visible={false} caption="Date2_OMHeader"></Column>
                <Column dataField="userdefineddate3" visible={false} caption="Date3_OMHeader"></Column>
                <Column dataField="userdefineddate4" visible={false} caption="Date4_OMHeader"></Column>
                <Column dataField="userdefineddate5" visible={false} caption="Date5_OMHeader"></Column>
                <Column dataField="userdefineddate6" visible={false} caption="Date6_OMHeader"></Column>
                <Column dataField="userdefineddate7" visible={false} caption="Date7_OMHeader"></Column>
                <Column dataField="userdefineddate8" visible={false} caption="Date8_OMHeader"></Column>
                <Column dataField="userdefineddate9" visible={false} caption="Date9_OMHeader"></Column>
                <Column dataField="userdefineddate10" visible={false} caption="Date10_OMHeader"></Column>
                <Column dataField="userdefinedquantity1" visible={false} caption="Quantity1_OMHeader"></Column>
                <Column dataField="userdefinedquantity2" visible={false} caption="Quantity2_OMHeader"></Column>
                <Column dataField="userdefinedquantity3" visible={false} caption="Quantity3_OMHeader"></Column>
                <Column dataField="userdefinedquantity4" visible={false} caption="Quantity4_OMHeader"></Column>
                <Column dataField="userdefinedquantity5" visible={false} caption="Quantity5_OMHeader"></Column>
                <Column dataField="userdefinedquantity6" visible={false} caption="Quantity6_OMHeader"></Column>
                <Column dataField="userdefinedquantity7" visible={false} caption="Quantity7_OMHeader"></Column>
                <Column dataField="userdefinedquantity8" visible={false} caption="Quantity8_OMHeader"></Column>
                <Column dataField="userdefinedquantity9" visible={false} caption="Quantity9_OMHeader"></Column>
                <Column dataField="userdefinedquantity10" visible={false} caption="Quantity10_OMHeader"></Column>
                <Column dataField="transItemTotal" visible={false} caption="Item Total" />
                <Column dataField="transForeignItemTotal" visible={false} caption="Foreign Item Total" />
                <Column dataField="transDiscountBasisAmount" visible={false} caption="Discount BasisAmount" />
                <Column dataField="transForeignDiscountBasisAmount" visible={false} caption="Foreign Discount BasisAmount" />
                <Column dataField="transDiscountAmount" visible={false} caption="Discount Amount" />
                <Column dataField="transForeignDiscountAmount" visible={false} caption="Foreign Discount Amount" />
                <Column dataField="transTaxableAmount" visible={false} caption="Taxable Amount" />
                <Column dataField="transForeignTaxableAmount" visible={false} caption="Foreign Taxable Amount" />
                <Column dataField="transNonTaxableAmount" visible={false} caption="Non Taxable" />
                <Column dataField="transForeignNonTaxableAmount" visible={false} caption="Foreign Non Taxable Amount" />
                <Column dataField="transTaxBasisAmount" visible={false} caption="Tax Basis Amount" />
                <Column dataField="transForeignTaxBasisAmount" visible={false} caption="Foreign Tax Basis Amount" />
                <Column dataField="transTaxAmount" visible={false} caption="Tax Amount" />
                <Column dataField="transTotalAmount" visible={false} caption="Total Amount" />
                <Column dataField="transForeignTotalAmount" visible={false} caption="Foreign Total Amount" />
                <Column dataField="transForeignPaymentsAmount" visible={false} caption="Foreign Payments Amount" />
                <Column dataField="transBalanceDue" visible={false} caption="Balance Due" />
                <Column dataField="transForeignBalanceDue" visible={false} caption="Foreign Balance Due" />
                <Column dataField="transQuantityOrdered" visible={false} caption="Quantity Ordered" />
                <Column dataField="transQuantityShipped" visible={false} caption="Quantity Shipped" />
                <Column dataField="transQuantityBackOrder" visible={false} caption="Quantity Back Order" />
                <Column dataField="transFeesAdded" visible={false} caption="Fees Added" />
                <Column dataField="transFeesIncluded" visible={false} caption="Fees Included" />
                <Column dataField="transGrossWeight" visible={false} caption="Gross Weight" />
                <Column dataField="transNetWeight" visible={false} caption="Net Weight" />
                <Column dataField="customerCountry" visible={false} caption="Customer Country" />
                <Column dataField="customerTelephone1" visible={false} caption="Customer Telephone 1" />
                <Column dataField="customerTelephone2" visible={false} caption="Customer Telephone 2" />
                <Column dataField="customerFax1" visible={false} caption="Customer Fax 1" />
                <Column dataField="customerFax2" visible={false} caption="Customer Fax 2" />
                <Column dataField="customerModem1" visible={false} caption="Customer Modem 1" />
                <Column dataField="customerModem2" visible={false} caption="Customer Modem 2" />
                <Column dataField="customerCellPhone1" visible={false} caption="Customer Cell Phone 1" />
                <Column dataField="customerCellPhone2" visible={false} caption="Customer Cell Phone 2" />
                <Column dataField="customerPager1" visible={false} caption="Customer Pager 1" />
                <Column dataField="customerPager2" visible={false} caption="Customer Pager 2" />
                <Column dataField="consigneeCountry" visible={false} caption="Consignee Country" />
                <Column dataField="consigneeTelephone1" visible={false} caption="Consignee Telephone 1" />
                <Column dataField="consigneeTelephone2" visible={false} caption="Consignee Telephone 2" />
                <Column dataField="consigneeFax1" visible={false} caption="Consignee Fax 1" />
                <Column dataField="consigneeFax2" visible={false} caption="Consignee Fax 2" />
                <Column dataField="consigneeModem1" visible={false} caption="Consignee Modem 1" />
                <Column dataField="consigneeModem2" visible={false} caption="Consignee Modem 2" />
                <Column dataField="consigneeCellPhone1" visible={false} caption="Consignee Cell Phone 1" />
                <Column dataField="consigneeCellPhone2" visible={false} caption="Consignee Cell Phone 2" />
                <Column dataField="consigneePager1" visible={false} caption="Consignee Pager 1" />
                <Column dataField="consigneePager2" visible={false} caption="Consignee Pager 2" />
                <Toolbar>
                    <Item location="before">
                    <PrintReportMenu selectedRecord={selectedRecord} />
                    </Item>
                    <Item location="before">
                    <SalesOrderOptionsButton
                        tabType={OptionsTabType.EdiWeb}
                        customerId={selectedCustomerId}
                        selectedRowId={selectedRowId}
                        accessToken={accessToken}
                        onRefresh={() => dataGrid.current?.instance().refresh()}
                    />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <EdiWebTabs ref={childRef} accessToken={accessToken}/>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(EdiWebSearchResult);